import { useTranslation } from 'react-i18next'

import { Button } from '@/shared/components/ui/button'

/** Field-level load failure with an actionable retry (no apology, see spec §6). */
export const FieldLoadError = ({
	label,
	onRetry,
	testId,
	message,
}: {
	label: string
	onRetry: () => void
	testId?: string
	message?: string
}) => {
	const { t } = useTranslation()

	return (
		<div className='space-y-1' data-testid={testId}>
			<div className='text-sm font-medium'>{label}</div>
			<div className='flex items-center gap-2 text-sm text-destructive'>
				<span>
					{message ??
						t('pr_tactic_competitors_load_error', {
							defaultValue: "Couldn't load competitors.",
						})}
				</span>
				<Button
					type='button'
					variant='link'
					size='sm'
					className='h-auto p-0'
					onClick={onRetry}
					data-testid={testId ? `${testId}-retry` : undefined}
				>
					{t('general_retry', {
						defaultValue: 'Retry',
					})}
				</Button>
			</div>
		</div>
	)
}
